import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from '@famly/mf_data-display_text';
import { Stack } from '@famly/mf_layout_stack';
import { Box } from '@famly/mf_layout_box';
import { getInitials } from 'signin-app/util/get-initials';
import { PersonImage } from './person-image';
export const UserOverview = (props) => {
    const { image, name, subText, subTextBold } = props;
    return (_jsxs(Stack, { justifyContent: "center", alignItems: "center", flexDirection: "column", "data-e2e-id": "user-overview", color: "n400", children: [_jsx(PersonImage, { image: image, initials: getInitials(name) }), _jsx(Box, { mt: 2, children: _jsx(Text, { variant: "h5", emphasized: true, children: name }) }), Boolean(subText || subTextBold) && (_jsx(Stack, { alignItems: "center", children: _jsxs(Text, { variant: "body-small", children: [subText, " ", subTextBold] }) }))] }));
};
